"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContactUsTrayPanelGroup = ContactUsTrayPanelGroup;
exports.ContactUsTrayPanelGroupItem = ContactUsTrayPanelGroupItem;
exports.PanelGroupItem = exports.PanelGroup = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _react2 = require("@linaria/react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _index = require("./index.js");
var _index2 = _interopRequireDefault(require("../../../elements/other/actions/index"));
var _text = _interopRequireDefault(require("@ux/text"));
var _density = require("@site/pattern-library-utils/density");
const PanelGroup = exports.PanelGroup = /*#__PURE__*/(0, _react2.styled)("ul")({
  name: "PanelGroup",
  class: "pl-pophkop"
});
const PanelGroupItem = exports.PanelGroupItem = /*#__PURE__*/(0, _react2.styled)("li")({
  name: "PanelGroupItem",
  class: "pl-p1hs40xv"
});
const TextContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "TextContainer",
  class: "pl-t1nvt6pi"
});
const CTAContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "CTAContainer",
  class: "pl-c59efib"
});

/**
 * Contact Us Tray Panel Group Item component.
 *
 * @param {Object} props React props
 * @param {string} props.description text string
 * @param {string} props.disclaimer text string
 * @param {string} props.ctas buttons
 * @returns {React.ReactElement} Primary Nav Tray Panel List Item
 * @public
 */
function ContactUsTrayPanelGroupItem({
  description,
  ctas,
  disclaimer
}) {
  const sanitizedCtas = ctas?.map(cta => {
    if (typeof cta?.href === 'string') {
      cta.href = cta?.href.replace(/&#8234;|&#8236;/g, '');
    }
    return cta;
  }) || ctas;
  return /*#__PURE__*/_react.default.createElement(PanelGroupItem, {
    "data-cy": "contact-us-tray-panel-list-item"
  }, /*#__PURE__*/_react.default.createElement(TextContainer, null, description), ctas && /*#__PURE__*/_react.default.createElement(CTAContainer, null, /*#__PURE__*/_react.default.createElement(_index2.default, {
    actionsLayout: "button-set",
    ctas: sanitizedCtas
  })), disclaimer && /*#__PURE__*/_react.default.createElement(TextContainer, null, /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "paragraph",
    size: -2
  }, disclaimer)));
}
ContactUsTrayPanelGroupItem.propTypes = {
  description: _propTypes.default.string,
  disclaimer: _propTypes.default.string,
  ctas: _propTypes.default.array
};

/**
 * Contact Us Tray Panel Group component.
 *
 * @param {Object} props React props
 * @param {string} props.heading Title
 * @param {array} props.items menu items
 * @param {string} props.chatNowId used for ChatNow
 * @param {string} props.chatNowExample used for ChatNow
 * @returns {React.ReactElement} Primary Nav Tray Panel List
 * @public
 */
function ContactUsTrayPanelGroup({
  heading,
  items,
  chatNowId,
  chatNowExample
}) {
  if (chatNowId) {
    return /*#__PURE__*/_react.default.createElement(PanelGroup, {
      "data-cy": "contact-us-tray-panel-group"
    }, /*#__PURE__*/_react.default.createElement(PanelGroupItem, {
      id: chatNowId
    }, chatNowExample));
  }
  return /*#__PURE__*/_react.default.createElement(PanelGroup, (0, _extends2.default)({
    "data-cy": "contact-us-tray-panel-group"
  }, chatNowId ? {
    id: chatNowId
  } : {}), heading && /*#__PURE__*/_react.default.createElement(PanelGroupItem, null, /*#__PURE__*/_react.default.createElement(TextContainer, null, /*#__PURE__*/_react.default.createElement("strong", null, heading))), items?.map((item, i) => /*#__PURE__*/_react.default.createElement(ContactUsTrayPanelGroupItem, (0, _extends2.default)({
    key: i
  }, item))));
}
ContactUsTrayPanelGroup.propTypes = {
  heading: _propTypes.default.string,
  chatNowId: _propTypes.default.string,
  chatNowExample: _propTypes.default.object,
  items: _propTypes.default.arrayOf(ContactUsTrayPanelGroupItem)
};